import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { App } from './App';
import './main.css';

if (import.meta.env.MODE === 'production') {
  void import('@sentry/react').then((Sentry) => {
    Sentry.init({
      dsn: 'https://8704254e59b2b8fbe4358ec607232744@o4507517887447040.ingest.us.sentry.io/4507527348092928',
      enabled: import.meta.env.MODE === 'production',
      integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.replayIntegration(),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: [/^\//, /^https:\/\/api\.moderately\.ai/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  });

  mixpanel.init('0da417a21b47db7f6af0ee3311bc5274', {
    debug: false,
    track_pageview: false,
    persistence: 'localStorage',
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
